module.exports = __webpack_public_path__ + "site/img/fbzh.2f845a59.png";